import { makeStyles, Slider, withStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    // marginTop: spacing(5),
    alignItems: 'center',
    flexDirection: 'column',
    [breakpoints.up('lg')]: {
      margin: spacing(3, 15.75, 0, 15.75),
    },
    [breakpoints.down('lg')]: {
      margin: '30px',
    },
  },
  containerX: {
    [breakpoints.up('sm')]: {
      marginTop: '30px',
    },
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '800px',
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    [breakpoints.down('sm')]: {
      width: '400px',
      flexDirection: 'column-reverse',
      margin: spacing(2, 1),
      padding: spacing(1, 0),
    },
    '@media (min-width:426px) and (max-width:825px)': {
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(1),
    },
    '@media (max-width:375px)': {
      flexDirection: 'column-reverse',
      width: '330px',
    },
    '@media (max-width:320px)': {
      flexDirection: 'column-reverse',
      width: '280px',
    },
  },
  logoImage: {
    width: '1000px',
    height: '100%',
    [breakpoints.down('sm')]: {
      left: spacing(9),
      width: 'auto',
      height: '100px',
      top: spacing(2),
      // padding: spacing(1),
      marginTop: spacing(2),
      display: 'flex',
    },
  },
  logoContainer: {
    [breakpoints.down('sm')]: {
      // height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(6),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  subTitle: {
    margin: spacing(1),
    fontSize: spacing(3),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    // width: '800px',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
      margin: spacing(2),
    },
    '@media (max-width:375px)': {
      fontSize: spacing(1.5),
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1.5),
    },
  },
  hlsPlayer: {
    width: '800px',
    '@media (min-width:426px) and (max-width:825px)': {
      width: '99%',
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(2, 1),
    },
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '280px',
    },
  },
  hlsPlayerLoader: {
    width: '800px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1000,
    position: 'absolute',
    '@media (min-width:426px) and (max-width:575px)': {
      margin: spacing(0, 1),
      top: '20%',
    },
    '@media (min-width:576px) and (max-width:960px)': {
      margin: spacing(0, 1),
      top: '30%',
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(0, 1),
      top: '20%',
    },
    [breakpoints.up('md')]: {
      width: '650px',
      top: '30%',
    },
    '@media (max-width:375px)': {
      width: '330px',
      top: '20%',
    },
    '@media (max-width:320px)': {
      width: '280px',
      top: '25%',
    },
  },
  slider: {
    '@media (min-width:426px) and (max-width:825px)': {
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(2, 1),
    },
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '280px',
    },
  },
  thumbnail: {
    position: 'absolute',
    top: '-70px',
    width: '150px',
    height: '80px',
    zIndex: 1000,
    transform: 'translateX(-50%)',
    clipPath: 'polygon(0% 0%, 100% 0, 100% 95%, 53% 95%, 50% 100%, 46% 95%, 0 95%)',
  },
  backButton: {
    marginTop: spacing(1),
    // backgroundColor: palette.green.dark,
    color: palette.green.main,
    border: `2px solid ${palette.green.dark}`,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.white.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(0),
    },
  },
  confirmDisabledButton: {
    backgroundColor: palette.gray.light,
    color: palette.green.main,
    marginTop: spacing(1),
    width: spacing(15),
    margin: spacing(2, 0, 2, 2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(1, 0, 1, 0),
    },
  },
  confirmButton: {
    marginTop: spacing(1),
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(15),
    margin: spacing(2, 0, 2, 2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(1, 0, 1, 0),
    },
  },
  extendTimeButton: {
    marginTop: spacing(1),
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(2),
    margin: spacing(2, 0, 2, 2),
    letterSpacing: '0px',
    textTransform: 'unset',
    padding: spacing(0),
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '50%',
      margin: spacing(1, 0, 1, 0),
    },
  },
  extendClickedTimeButton: {
    marginTop: spacing(1),
    backgroundColor: palette.gray.main,
    color: palette.white.main,
    width: spacing(2),
    margin: spacing(2, 0, 2, 2),
    letterSpacing: '0px',
    textTransform: 'unset',
    padding: spacing(0),
    // border: '2px solid red',
    '&:hover': {
      backgroundColor: palette.gray.main,
    },
    [breakpoints.down('sm')]: {
      width: '50%',
      margin: spacing(1, 0, 1, 0),
    },
  },
  inTimeText: {
    marginLeft: '10px',
    marginRight: '20px',
  },
  outTimeText: {
    marginRight: '10px',
  },
  playerContainer: {
    position: 'relative',
    width: '100%',
    height: '300px',
  },
  sliderContainer: {
    position: 'relative',
    marginTop: '5px',
    [breakpoints.down('sm')]: {
      width: '100%',
      padding: spacing(0.75),
      marginTop: spacing(0),
    },
  },
  thumbnailPreview: {
    position: 'absolute',
    bottom: '50px', // Position the thumbnail above the slider
    transform: 'translateX(-50%)',
    pointerEvents: 'none',
    zIndex: 10,
  },
  hoverTime: {
    textAlign: 'center',
    marginTop: '5px',
    background: '#000',
    color: '#fff',
    padding: '2px 5px',
    borderRadius: '3px',
    fontSize: '12px',
  },
  playerIndicator: {
    top: '10px', // Adjust based on slider height
    transform: 'translateX(-50%)',
    width: '15px',
    height: '15px',
    backgroundColor: '#C8C8C8', // Marker color
    // borderRadius: '50%',
    pointerEvents: 'none', // Prevent interfering with slider interaction
    position: 'absolute',
    [breakpoints.down('sm')]: {
      top: '22px', // Adjust based on slider height
    },
  },
  playerIndicatorIsPlaying: {
    transition: 'left 0.3s linear', // Smooth transition for marker movement
  },

  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: '#fff',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '30px',
    zIndex: 1,
    '@media (max-width: 600px)': {
      top: '40%', // Adjust for smaller screens
      width: '50px',
      height: '50px',
      fontSize: '24px',
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    marginTop: '20px',
  },
  videoContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  playButtonMobile: {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: '#fff',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '30px',
    zIndex: 1,
    marginTop: '20px',
  },
  timeExtendContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  timeExtendButtonContainer: {
    [breakpoints.down('sm')]: {
      display: 'flex',
      gap: '5px',
    },
  },
}));

export const VideoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -7,
    marginLeft: -12,
    height: '20px',
    width: '20px',
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
      pointerEvents: 'none',
    },
    '& .MuiSlider-root': {
      height: 24,
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    // borderRadius: 4,
  },
  rail: {
    height: 8,
    // borderRadius: 4,
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
})(Slider);
